import { SquaresPlusIcon } from "@heroicons/react/24/outline";

const EmptyListState = (props) => {
  return (
    <div className="flex items-center h-full">
      <div
        className={`flex flex-col items-center w-full${
          props.fullscreenList ? " mt-[28px] mb-24 mr-2" : " mt-10 mb-10"
        }`}
      >
        <SquaresPlusIcon
          className="h-10 w-10 text-gray-400"
          aria-hidden="true"
        />
        <h2 className="text-sm font-medium text-gray-900 mt-2 mb-1">
          {props.title}
        </h2>
        <p className="text-sm text-gray-500">{props.message} </p>
      </div>
    </div>
  );
};

export default EmptyListState;
